import type { InstantAssistantMessage, InstantAssistantMessageRole } from "@/types/assistant";

export type AssistantMessagePayload = Omit<InstantAssistantMessage, "role"> & {
  role?: string | number | null;
};

const ROLE_BY_INDEX: InstantAssistantMessageRole[] = ["operator", "assistant", "system"];

export function normalizeAssistantMessage(payload: AssistantMessagePayload): InstantAssistantMessage {
  return {
    messageId: payload.messageId,
    role: normalizeAssistantRole(payload.role),
    content: payload.content,
    createdAtUtc: payload.createdAtUtc,
    context: payload.context,
    attachments: payload.attachments,
    isSlowPath: Boolean(payload.isSlowPath),
    isDegraded: Boolean(payload.isDegraded),
    failureReason: payload.failureReason,
    contextSummary: payload.contextSummary ?? null,
  };
}

export function normalizeAssistantRole(
  role: string | number | null | undefined,
): InstantAssistantMessageRole {
  if (typeof role === "number" && Number.isInteger(role)) {
    const mapped = ROLE_BY_INDEX[role];
    if (mapped) {
      return mapped;
    }
  }

  if (typeof role === "string") {
    const normalized = role.trim().toLowerCase();
    if (normalized === "operator" || normalized === "assistant" || normalized === "system") {
      return normalized;
    }
    if (normalized === "user") {
      return "operator";
    }
  }

  return "assistant";
}
